export async function parseApiResponse(response) {
  const contentType = response.headers.get('content-type') || '';
  const rawText = await response.text();

  if (!rawText.trim()) {
    return {};
  }

  if (contentType.includes('application/json')) {
    try {
      return JSON.parse(rawText);
    } catch (_error) {
      throw new Error('Backend returned invalid JSON.');
    }
  }

  const snippet = rawText.slice(0, 120).trim();
  throw new Error(
    snippet.startsWith('<!DOCTYPE') || snippet.startsWith('<html')
      ? 'Backend returned HTML instead of JSON. Make sure the deployed API is available at https://laftekbusinesssolutions.com/api/.'
      : 'Backend returned an unexpected response.'
  );
}
